import Bs4Stores from '../Bs4Stores';
import Bs4MainDispatch from '../Bs4MainDispatch';

import {formatterDate, editorDate} from './Bs4ColumnsDate';
import {formatterTime, formatterSumTime, editorTime} from './Bs4ColumnsTime';
import {formatterDateTime, editorDateTime} from './Bs4ColumnsDateTime';
import editorMultiple from './Bs4ColumnsMultiple';
import {formatterSelect, editorSelect} from './Bs4ColumnsSelect';
import {formatterJSON} from './Bs4ColumnsJson';
import {formatterSum} from './Bs4ColumnsSum';
import editorTextarea from './Bs4ColumnsTextarea';
import {isNullOrNaN} from '../Bs4Components/Bs4Utils';

const Bs4Js = {
  //parsuje na float oraz zamienia przecinki na kropki
  parseFloat: function(val) {
    if(val !== undefined && val !== null && val !== '') {
      val = val.toString();
      val = val.split(',').join('.');
      val = val.split(' ').join('');
      return parseFloat(val);
    }
    return val;
  },

  // zwraca tlumaczenie z locale dla wybranego jezyka
  getCaption: function (a_module, akey) {
    if (!Bs4Js.locale[a_module]) {
      return akey;
    }

    var ret = Bs4Js.locale[a_module][akey];
    if (ret) {
      return ret;
    } else {
      return akey;
    }
  },
};

const getMoney = (floatVal, formatterParams) => {
  floatVal = parseFloat(floatVal);
	let sign = "";
	let number, integer, decimal, rgx;

	const decimalSym = formatterParams.decimal || ".";
	// const thousandSym = formatterParams.thousand || ",";
  const thousandSym = formatterParams.thousand || false;
	const negativeSign = formatterParams.negativeSign || "-";
	const symbol = formatterParams.symbol || "";
	const after = !!formatterParams.symbolAfter;
	const precision = typeof formatterParams.precision !== "undefined" ? formatterParams.precision : 2;

	if(isNullOrNaN(floatVal)) {
		return '';
	}

	if(floatVal < 0){
		floatVal = Math.abs(floatVal);
		sign = negativeSign;
	}

	number = precision !== false ? floatVal.toFixed(precision) : floatVal;
	number = String(number).split(".");

	integer = number[0];
	decimal = number.length > 1 ? decimalSym + number[1] : "";

	if (formatterParams.thousand !== false) {
		rgx = /(\d+)(\d{3})/;

		while (rgx.test(integer)){
			integer = integer.replace(rgx, "$1" + thousandSym + "$2");
		}
	}

	return after ? sign + integer + decimal + symbol : sign + symbol + integer + decimal;  
}

const isRowInFooter = (element, level) => {  
  if (!level) level = 0
  if (level > 3) return false;
  if (element?.className?.includes('tabulator-footer')) return true;
  if (element?.parentElement) return isRowInFooter(element.parentElement, level+1)
  return false;
}

const formatterSumOld = function(cell, formatterParams, onRendered) {
  const footer = isRowInFooter(cell.getRow().getElement())

  const value = cell.getValue();
  const bs4Totals = formatterParams.bs4Totals();
  const column = cell.getColumn();
  const field = column.getField();
  let total = null;
  if (bs4Totals) total = bs4Totals[field];
  
  const value1 = getMoney(value, formatterParams);
  const total1 = getMoney(total, formatterParams);
  
  // 2025-01-28 61453 – Podsumowanie zaznaczonych wierszy [Core]
  const tabulator = cell.getRow().getTable();
  const selectedData = tabulator.getSelectedData();
  const selectedSumValue = getMoney(selectedData.reduce((valueSum, data) => valueSum + data[field], 0), formatterParams);

  if (total && footer && bs4Totals.lastPage > 1) {        
    if (selectedData.length > 0) {
      return `<span>${value1}</span><br/><span>${total1}</span><br/><span>(${selectedData.length}) ${selectedSumValue}</span>`;
    }

    return `<span>${value1}</span><br/><span>${total1}</span>`;
  }

  if (selectedData.length > 0) {
    return `<span>${value1}</span><br/><span>(${selectedData.length}) ${selectedSumValue}</span>`;
  }
  
  return value1;
}

const formatterHtml = function(cell, formatterParams, onRendered) {  
  if (formatterParams.breakColumnContent) {
    cell.getElement().style.whiteSpace = 'pre-line';
    //console.log('..column breakColumnContent...', cell.getValue(), cell.getElement(),)
  }
  return cell.getValue();
}

const formatterMoney = function(cell, formatterParams, onRendered) {  
  let floatVal = parseFloat(cell.getValue())
	if(isNullOrNaN(floatVal)){
		return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
	}

  return getMoney(floatVal, formatterParams);
}

const formatterHeader = function(cell, formatterParams, onRendered) {  
  console.log('...formatterHeader...', cell, cell.getElement(), cell.getElement());  
  cell.getElement().style.height = '53px';
  cell.getElement().style.border = '2px solid';
  cell.getElement().style.backgroundColor = '#0f0';
  return cell.getValue();
}

// export default function(cell, formatterParams, onRendered){
// 	cell.getElement().classList.add("tabulator-row-handle");
// 	return "<div class='tabulator-row-handle-box'><div class='tabulator-row-handle-bar'></div><div class='tabulator-row-handle-bar'></div><div class='tabulator-row-handle-bar'></div></div>";
// }

export const formatterHandle = (cell, formatterParams, onRendered) => {
  cell.getElement().classList.add("tabulator-row-handle");
  return '<div class="fa-solid fa-grip-dots"></div>'
}

const simpleFormatterSelect = (cell, formatterParams, onRendered) => {
  const value = cell.getValue();
  if (!value) return value;
  let valueArray = [];
  if (Array.isArray(value)) valueArray = value;
  else valueArray = value.split(',');
  //console.log('...simpleFormatterSelect...', cell.getValue(), valueArray, formatterParams)
  let newValue = '';
  let separator = '';
  valueArray.forEach(value => {
    let v = formatterParams[value];
    if (!v) v = value;
    if (!parseFloat(value) && !v) return;
    newValue += separator;
    newValue += v;
    separator = ', ';
  });
  return newValue;
}

export function getColumn(column, bs4Report) {
  const columnT = {
    title: column.text,
    field: column.dataIndex,
    width: column.width,
    formatter: formatterHtml,
    resizable: true,
    variableHeight: true,
    visible: !column.hidden,
    headerSort: column.sortable,    
    //titleFormatter: formatterHeader,
  };  

  const ppppppppp = parseInt(column.precision);
  const precision = isNullOrNaN(ppppppppp) ? 2 : ppppppppp;
  // if (column.xtype === 'colbs4hourmin') {
  //   column.summaryType = 'sum';
  // }

  if (column?.summaryType ==="sum") {
    columnT.bottomCalc = "sum";
    switch (column.xtype) {    
      case "colbs4float":
        columnT.bottomCalcParams = {precision: precision};
        columnT.bottomCalcFormatter = formatterSum;
        columnT.bottomCalcFormatterParams = {
          bs4Totals: bs4Report.getBs4Totals,
          decimal:",",
          thousand:" ",
          symbol: null,
          symbolAfter: null,
          precision: precision,
        }

        if (precision === 0) columnT.bottomCalcFormatterParams.thousand = false;
        
        if (column.bs4colprefix) {
          columnT.bottomCalcFormatterParams.symbol = column.bs4colprefix;
          columnT.bottomCalcFormatterParams.symbolAfter = false;
        } else if (column.bs4colsuffix) {
          columnT.bottomCalcFormatterParams.symbol = column.bs4colsuffix;
          columnT.bottomCalcFormatterParams.symbolAfter = true;
        }         
        break;
  
      case "colbs4hourmin":
        columnT.bottomCalcFormatter = formatterSumTime;
        columnT.bottomCalcFormatterParams = {
          bs4Totals: bs4Report.getBs4Totals,          
        }
        break;              
    }    
  }

  if (column?.bs4calculation) {
    columnT.mutator = function(value, data, type, params, component) {
      //value - original value of the cell
      //data - the data for the row
      //type - the type of mutation occurring  (data|edit)
      //params - the mutatorParams object from the column definition
      //component - when the "type" argument is "edit", this contains the cell component for the edited cell, otherwise it is the column component for the column
      
      // !!! Zmienna record jest użuwana niejawnie przez eval.
      const record = {data: data} 
      return eval(params.bs4calculation);
    }
    
    columnT.mutatorParams = {
      bs4calculation: column.bs4calculation,
    }
  } 
  
  //column.xtype = "colbs4string";
  switch (column.xtype) {
    case "colbs4json":      
      columnT.formatterParams = {bs4Report: bs4Report};    
      columnT.formatter = formatterJSON;      
      break;    

    case "colbs4string":
      columnT.formatter = formatterHtml; //"html";
      if (column.breakColumnContent) columnT.formatterParams = {breakColumnContent: true};    
      if (column?.editor !== false) {
        columnT.editor = "input";              
      }
      //console.log('...text    ...', columnT.text, columnT.editor, columnT)
      break;

    case "colbs4textarea":             
      //columnT.formatter = "textarea";           
      columnT.formatter = formatterHtml; //"html";
      columnT.formatterParams = {breakColumnContent: true}; 
      if (column?.editor !== false) {        
        columnT.editor = editorTextarea;
        //columnT.editor = 'textarea';
      }
      //console.log('...textarea...', columnT.title, columnT.editor, columnT)
      break;

    case "colbs4float":
      columnT.headerHozAlign = "right";
      columnT.hozAlign = "right";
      columnT.sorter = "number";
      columnT.formatter = formatterMoney;
      
      columnT.formatterParams = {
        decimal:",",
        thousand:" ",
        symbol: null,
        symbolAfter: null,
        precision: precision,
      }

      if (precision === 0) columnT.formatterParams.thousand = false;

      if (column.bs4colprefix) {
        columnT.formatterParams.symbol = column.bs4colprefix;
        columnT.formatterParams.symbolAfter = false;
      } else if (column.bs4colsuffix) {
        columnT.formatterParams.symbol = column.bs4colsuffix;
        columnT.formatterParams.symbolAfter = true;
      } 

      if (column?.editor !== false) {
        columnT.editor = "number";
        columnT.editorParams = {
          //min:0,
          //max:100,
          step:1,
          // elementAttributes:{
          //     maxlength:"10", //set the maximum character length of the input element to 10 characters
          // },
          //mask:"AAA-999",
          selectContents: true,
          verticalNavigation: "table", //'editor', //"table", //up and down arrow keys navigate away from cell without changing value
        }
      }
      break;

    case "colbs4hourmin":
      columnT.formatter = formatterTime;
      if (column?.editor !== false) {
        columnT.editor = editorTime;
        columnT.editorParams = {
          //verticalNavigation: 'editor',
          min_interval : column.min_interval
        }        
      }
      break;
      
    case "colbs4select":
      columnT.formatter = formatterSelect;
      //columnT.formatterParams = Bs4Stores.getLookup(column.bs4store);
      columnT.formatterParams = Bs4Stores.getBs4Store(column.bs4store);
      if (column?.editor !== false) {              
        columnT.editor = editorSelect
        columnT.editorParams = {
          //values: Bs4Stores.getValueLabel(column.bs4store),
          values: Bs4Stores.getBs4Store(column.bs4store),
          multiselect: false,
        }
      }
      break;

    case "colbs4multiple":
      columnT.formatter = simpleFormatterSelect;
      columnT.formatterParams = Bs4Stores.getLookup(column.bs4store);
      if (column?.editor !== false) {          
        //columnT.editor = 'select'    
        columnT.editor = editorMultiple
        columnT.editorParams = {
          //values: Bs4Stores.getValueLabel(column.bs4store),
          values: Bs4Stores.getBs4Store(column.bs4store),
          multiselect: true,
        }
      }
      console.log('...colbs4multiple...', columnT.text, columnT)
      break;    

    case "colbs4date":
      columnT.formatter = formatterDate;
      if (column?.editor !== false) {
        columnT.editor = editorDate;
        columnT.editorParams = {
          ...column,
        }
        
      }
      break;

    case "colbs4datetime":
      columnT.formatter = formatterDateTime;
      if (column?.editor !== false) {              
        columnT.editor = editorDateTime;
        columnT.editorParams = {
          ...column,
        }
      }
      break;
  }

  // console.log('...tabulatoe.col...', columnT, column)
  return columnT;
}